export default __webpack_public_path__ + "static/media/dragon_ball_preview.7248f207.png";